import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {Col, Row} from 'reactstrap';
import './TypZaborListItem.scss';

const renderDruhUcel = (druhUcel, index) => (
    <span className="ucel" key={"druhUcel-" + index}>{druhUcel.nazev || druhUcel}</span>
);

const TypZaborListItem = ({typZabor, active}) => {
    const {id, nazev, popis, ikona, druhUcelList} = typZabor;
    return (
        <Row className={classNames('typ', {active})} key={'typZabor-' + id}>
            <Col xs={12}>
                <div className="media">
                    <div className="media-left">
                        <a href="#">
                            <img className="media-object"  src={`${serverContextPath}/img/${ikona}`} />
                        </a>
                    </div>
                    <div className="media-body">
                        <h4 className="nazev">{nazev}</h4>
                        <div className="popis">{popis}</div>
                        {druhUcelList && druhUcelList.map(renderDruhUcel)}
                    </div>
                </div>
            </Col>
        </Row>
    )
};

TypZaborListItem.renderListItem = (typZabor, active) => (
    <TypZaborListItem typZabor={typZabor} active={active}/>
);

TypZaborListItem.propTypes = {
    typZabor: PropTypes.object.isRequired,
    active: PropTypes.bool
};

TypZaborListItem.defaultProps = {
    active: false,
};

export default TypZaborListItem;
